import { useState } from 'react';
import './Contatos.css';
import Maps from '../../components/Maps';
import emailjs from 'emailjs-com';

function Contatos() {
  const [formData, setFormData] = useState({ nomeCompleto: '', email: '', celular: '', telefone: '', assunto: '', dataInicio: '', dataFinal: '' });

  const handleInputChange = (e) => setFormData({ ...formData, [e.target.name]: e.target.value });
  const formatarData = (dataISO) => dataISO ? dataISO.split('-').reverse().join('/') : '';

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = { ...formData, dataInicio: formatarData(formData.dataInicio), dataFinal: formatarData(formData.dataFinal) };
    emailjs.send('service_5sidzo9', 'template_y2lokql', data, 'A4NEFYxu9Ww59nTvN')
      .then(() => alert('Mensagem enviada com sucesso!'))
      .catch(() => alert('Erro ao enviar a mensagem.'));
  };

  return (
    <div className="container my-5 py-4">
      <div className="row gy-5">
        <div className="col-12 col-lg-5 order-2 order-lg-1">
          <div className="contact-info-block mb-4">
            <h2 className="title-text mb-4">Onde estamos</h2>
            <p className="text-muted"><i className="bi bi-geo-alt-fill text-gold me-2"></i>R. José Tomé Filho, 26 - Santo Hilário, Pimenta - MG, 35585-000</p>
          </div>
          <Maps />
        </div>

        <div className="col-12 col-lg-7 order-1 order-lg-2">
          <div className="form-card p-4 p-md-5">
            <h3 className="form-title">Preencha o Formulário</h3>
            <p className="text-muted mb-4">Em breve entraremos em contato para ajudar na sua reserva.</p>
            
            <form onSubmit={handleSubmit}>
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label">Nome Completo</label>
                  <input type="text" className="form-control custom-input" name="nomeCompleto" value={formData.nomeCompleto} onChange={handleInputChange} required />
                </div>
                <div className="col-md-6">
                  <label className="form-label">E-mail</label>
                  <input type="email" className="form-control custom-input" name="email" value={formData.email} onChange={handleInputChange} required />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Celular</label>
                  <input type="text" className="form-control custom-input" name="celular" value={formData.celular} onChange={handleInputChange} required />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Assunto</label>
                  <select className="form-select custom-input" name="assunto" value={formData.assunto} onChange={handleInputChange} required>
                    <option value="">Selecione...</option>
                    <option value="Reserva">Reserva</option>
                    <option value="informacoes">Informações</option>
                    <option value="outro">Outro</option>
                  </select>
                </div>
                <div className="col-md-6">
                  <label className="form-label">Check-in</label>
                  <input type="date" className="form-control custom-input" name="dataInicio" value={formData.dataInicio} onChange={handleInputChange} required />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Check-out</label>
                  <input type="date" className="form-control custom-input" name="dataFinal" value={formData.dataFinal} onChange={handleInputChange} min={formData.dataInicio} required />
                </div>
                <div className="col-12 mt-4">
                  <button type="submit" className="btn btn-custom-action w-100">Enviar Mensagem</button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Contatos;